<template>
  <div style="height: inherit">

    <b-overlay :show="showLoading" spinner-variant="primary">

      <b-modal centered size="sm" id="modal-prevent-closing" ref="add-to-cart-modal" :title="product.Description"
        hide-footer>
        <b-form-input placeholder="La quantité demandée" ref="qte-input" v-model="requestedQte" type="number"
          @keyup.enter="handleOk"></b-form-input>
        <div class="d-block text-center">
          <b-button variant="relief-success" class="mt-1" @click="handleOk">Valider</b-button>
        </div>
      </b-modal>

      <div id="products-list">
        <b-card>
          <ag-grid v-if="filters.pages == 'Promotions'" :agGrid="{ ...agGrid, columnDefs: promotionsColumnDefs }"
            :pageTitle="pageTitle" @refresh="loadData" ref="agGrid" />
          <ag-grid v-else-if="filters.pages == 'Répartitions'"
            :agGrid="{ ...agGrid, columnDefs: distributionsColumnDefs }" :pageTitle="pageTitle" @refresh="loadData"
            ref="agGrid" />
          <ag-grid v-else :agGrid="{ ...agGrid, columnDefs: columnDefs }" :pageTitle="pageTitle" @refresh="loadData"
            ref="agGrid" />
        </b-card>
      </div>

      <!-- Sidebar -->
      <portal to="content-renderer-sidebar-detached-left">
        <shop-left-filter-sidebar :filters="filters" :filter-options="filterOptions" :showLoading="showLoading"
          :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar" @triggerFilter="handleEventFilter"
          @pageChanged="pageChanged" />
      </portal>

    </b-overlay>
  </div>
</template>

<script>
import { useResponsiveAppLeftSidebarVisibility } from '@core/comp-functions/ui/app'
import ShopLeftFilterSidebar from './ActualitiesShopLeftFilterSidebar.vue'
import axios from "@/libs/axios";
import AgGrid from "@/views/components/ag-grid/AgGrid.vue"
import BadgeCellRenderer from "@/views/components/ag-grid/BadgeCellRenderer.vue";
import ButtonCellRenderer from "@/views/components/ag-grid/ButtonCellRenderer.vue"
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { saveOrder } from '@/utils/indexDB/index';
import { formatPrice } from "@/utils/formatting";

export default {
  components: {
    AgGrid,
    // SFC
    ShopLeftFilterSidebar,
  },
  data() {
    return {
      product: {
        Description: ""
      },
      requestedQte: '',
      columnDefs: [
        {
          headerName: "N°",
          field: "No",
          width: 100
        },
        {
          headerName: "Description",
          field: "Description",
        },
        {
          headerName: "Fournisseur",
          field: "Vendor_Name",
        },
        {
          headerName: "Prix H.T",
          field: "Unit_Price",
          valueGetter: function (tr) {
            return formatPrice(tr.data.Unit_Price);
          },
          cellClass: 'right-customeCellRender',
          headerClass: 'right-customeHeaderRender',
          width: 70
        },
        {
          headerName: "Famille",
          field: "Gen_Prod_Posting_Group",
          cellRendererFramework: 'badgeCellRenderer',
          cellRendererParams: { componentName: "Actuality", columnName: "Family" },
          width: 90
        },
        {
          sortable: false,
          resizable: false,
          filter: false,
          cellClass: 'centered-customeCellRender',
          cellRendererFramework: 'buttonCellRenderer',
          cellRendererParams: { componentName: "Actuality", onButtonClick: this.handleCartActionClick, icon: "shopping_cart", variant: "outline-success" },
          headerName: '',
          width: 50
        },
        {
          sortable: false,
          resizable: false,
          filter: false,
          cellClass: 'centered-customeCellRender',
          cellRendererFramework: 'buttonCellRenderer',
          cellRendererParams: { componentName: "Actuality", onButtonClick: this.showDetails, icon: "more" },
          headerName: '',
          width: 50
        },
      ],
      promotionsColumnDefs: [
        {
          headerName: "N°",
          field: "No",
          width: 100
        },
        {
          headerName: "Description",
          field: "Description",
        },
        {
          headerName: "Fournisseur",
          field: "Vendor_Name",
        },
        {
          headerName: "Prix H.T",
          field: "Unit_Price",
          valueGetter: function (tr) {
            return formatPrice(tr.data.Unit_Price);
          },
          cellClass: 'right-customeCellRender',
          headerClass: 'right-customeHeaderRender',
          width: 70
        },
        {
          headerName: "Famille",
          field: "Gen_Prod_Posting_Group",
          cellRendererFramework: 'badgeCellRenderer',
          cellRendererParams: { componentName: "Actuality", columnName: "Family" },
          width: 90
        },
        {
          headerName: "Promotion",
          field: "Sales_threshold",
          valueGetter: params => params.data.Sales_threshold + " -> " + params.data.Free_Sales_Qty,
          width: 90,
        },
        {
          sortable: false,
          resizable: false,
          filter: false,
          cellClass: 'centered-customeCellRender',
          cellRendererFramework: 'buttonCellRenderer',
          cellRendererParams: { componentName: "Actuality", onButtonClick: this.handleCartActionClick, icon: "shopping_cart", variant: "outline-success" },
          headerName: '',
          width: 50
        },
        {
          sortable: false,
          resizable: false,
          filter: false,
          cellClass: 'centered-customeCellRender',
          cellRendererFramework: 'buttonCellRenderer',
          cellRendererParams: { componentName: "Actuality", onButtonClick: this.showDetails, icon: "more" },
          headerName: '',
          width: 50
        },
      ],
      distributionsColumnDefs: [
        {
          headerName: "N°",
          field: "No",
          width: 100
        },
        {
          headerName: "Description",
          field: "Description",
        },
        {
          headerName: "Fournisseur",
          field: "Vendor_Name",
        },
        {
          headerName: "Prix H.T",
          field: "Unit_Price",
          valueGetter: function (tr) {
            return formatPrice(tr.data.Unit_Price);
          },
          cellClass: 'right-customeCellRender',
          headerClass: 'right-customeHeaderRender',
          width: 70
        },
        {
          headerName: "Famille",
          field: "Gen_Prod_Posting_Group",
          cellRendererFramework: 'badgeCellRenderer',
          cellRendererParams: { componentName: "Actuality", columnName: "Family" },
          width: 90
        },
        {
          headerName: "Quota",
          field: "Open_Qty",
          width: 90,
        },
        {
          sortable: false,
          resizable: false,
          filter: false,
          cellClass: 'centered-customeCellRender',
          cellRendererFramework: 'buttonCellRenderer',
          cellRendererParams: { componentName: "Actuality", onButtonClick: this.handleCartActionClick, icon: "shopping_cart", variant: "outline-success" },
          headerName: '',
          width: 50
        },
        {
          sortable: false,
          resizable: false,
          filter: false,
          cellClass: 'centered-customeCellRender',
          cellRendererFramework: 'buttonCellRenderer',
          cellRendererParams: { componentName: "Actuality", onButtonClick: this.showDetails, icon: "more" },
          headerName: '',
          width: 50
        },
      ],
      agGrid: {
        rows: []
      },
      pageTitle: "Liste des arrivages",
      uri: 'navendpoints/getArrivals',
      showLoading: true,
      allProductsWithoutFilters: [],
      filters: {
        q: '',
        priceRangeDefined: 'Tous',
        categories: 'Tous',
        pages: "Arrivages",
        vendors: 'Tous',
        ratings: 1,
      },
      filterOptions: {
        priceRangeDefined: [
          { text: 'Tous', value: 'Tous' },
          { text: '<= 10 TND', value: '<=10' },
          { text: '10 TND - 30 TND', value: '10-30' },
          { text: '30 TND - 50 TND', value: '30-50' },
          { text: '>= 50 TND', value: '>=50' },
        ],
        categories: [
        ],
        pages: [
          "Arrivages",
          "Nouveautés",
          "Promotions",
          "Répartitions"
        ],
        vendors: [],
        ratings: [
          { rating: 1, value: 1 },
          { rating: 3, value: 3 },
          { rating: 4, value: 4 },
        ],
      },
    }
  },
  setup() {
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()
    return {
      mqShallShowLeftSidebar,
    }
  },
  methods: {
    handleCartActionClick(data) {
      console.log(data);
      this.product = data;
      this.requestedQte = "";
      this.$refs['add-to-cart-modal'].show();
      setTimeout(() => {
        this.$refs["qte-input"].focus();
      }, 400);
    },
    handleOk() {
      this.$refs['add-to-cart-modal'].hide();
      this.showLoading = true;
      this.$store.dispatch('app-portaldata/GET_INVENTORY', { code: this.product.No, qte: this.requestedQte }).then((response) => {
        this.showLoading = false;
        this.$toast({
          component: ToastificationContent,
          props: response,
        });
        if (!["warning", "danger"].includes(response.variant)) {
          let product = this.$store.getters['app-portaldata/getProductByNo'](this.product.No);
          product["promotion"] = response.promotion;
          product["state"] = !["warning", "danger"].includes(response.variant);
          product["Qte"] = this.requestedQte;
          saveOrder(product).then(() => {
            this.$store.dispatch('app-portaldata/COUNT_ORDER_LINES');
          });
        }
      }).catch((error) => {
        this.showLoading = false;
        console.log(error);
      });
    },
    showDetails(data) {
      this.$router.push('/product/' + data.No)
    },
    async pageChanged(page) {
      console.log(page);
      switch (page) {
        case "Arrivages":
          this.uri = 'navendpoints/getArrivals';
          this.pageTitle = "Liste des arrivages";
          this.loadData();
          return;
        case "Nouveautés":
          this.uri = 'navendpoints/getNovelties';
          this.pageTitle = "Liste des nouveautés";
          this.loadData();
          return;
        case "Promotions":
          this.uri = 'navendpoints/getPromotions';
          this.pageTitle = "Liste des promotions";
          this.loadData();
          return;
        case "Répartitions":
          this.uri = 'navendpoints/getDistributionItems';
          this.pageTitle = "Liste des répartitions";
          this.loadData();
          return;
      }
    },
    async handleEventFilter(data) {
      // Method to be executed when the custom event is emitted from the child component
      this.filters.q = "";
      this.showLoading = true;
      console.log('Custom event emitted from child component');
      console.log('Data:', data);
      this.agGrid.rows = this.allProductsWithoutFilters;
      await this.filterByCategory(data);
      await this.filterByVendor(data);
      await this.filterByPrice(data);
      await this.filterByClass(data);
      this.showLoading = false;
    },
    async filterByCategory(data) {
      if (data.categories != "Tous")
        this.agGrid.rows = this.agGrid.rows.filter(item => item.Gen_Prod_Posting_Group === data.categories);
    },
    async filterByVendor(data) {
      if (data.vendors != "Tous")
        this.agGrid.rows = this.agGrid.rows.filter(item => item.Vendor_Name === data.vendors);
    },
    async filterByPrice(data) {
      switch (data.ratings) {
        case 3:
          this.agGrid.rows = this.agGrid.rows.filter(item => item.Matrice.startsWith('A') || item.Matrice.startsWith('B'));
          break;
        case 4:
          this.agGrid.rows = this.agGrid.rows.filter(item => item.Matrice.startsWith('A'));
          break;
      }
    },
    async filterByClass(data) {
      if (data.rating != "Tous") {
        switch (data.priceRangeDefined) {
          case '<=10':
            this.agGrid.rows = this.agGrid.rows.filter(item => item.Unit_Price <= 10);
            break;
          case '10-30':
            this.agGrid.rows = this.agGrid.rows.filter(item => item.Unit_Price >= 10 && item.Unit_Price <= 30);
            break;
          case '30-50':
            this.agGrid.rows = this.agGrid.rows.filter(item => item.Unit_Price >= 30 && item.Unit_Price <= 50);
            break;
          case '>=50':
            this.agGrid.rows = this.agGrid.rows.filter(item => item.Unit_Price >= 50);
            break;
        }
      }
    },
    async loadData() {
      try {
        this.showLoading = true;
        const resp = await axios.get(this.uri);
        this.agGrid.rows = resp.data.value
        if (this.filters.pages == "Promotions")
          this.agGrid.rows = this.agGrid.rows.filter(item => item.Inventory >= (item.Free_Sales_Qty + item.Sales_threshold));
        else
          this.agGrid.rows = resp.data.value;
        if (this.filters.pages != "Répartitions")
          this.agGrid.rows = this.agGrid.rows.filter(item => item.Location_Code == JSON.parse(localStorage.getItem('userInfo')).locationCode);
        this.allProductsWithoutFilters = resp.data.value;
        await this.setCategories();
        await this.setVendors();

        this.filters.priceRangeDefined = 'Tous';
        this.filters.categories = 'Tous';
        this.filters.vendors = 'Tous';
        this.filters.ratings = 1;

        this.showLoading = false;
        if (!/Mobi/i.test(navigator.userAgent))
          this.$refs.agGrid.gridOptions.api.sizeColumnsToFit();
      } catch (error) {
        console.error('Error loading data:', error);
      }
    },
    async setCategories() {
      try {
        const distinctCategories = [...new Set(this.agGrid.rows.map(product => product.Gen_Prod_Posting_Group))];
        distinctCategories.unshift("Tous");
        this.filterOptions.categories = distinctCategories;
        // console.log(distinctCategories);
      } catch (error) {
        console.error('Error retrieving categories:', error);
      }
    },
    async setVendors() {
      try {
        const distinctVendoros = [...new Set(this.agGrid.rows.map(product => product.Vendor_Name))];
        distinctVendoros.unshift("Tous");
        this.filterOptions.vendors = distinctVendoros;
        // console.log(distinctVendoros);
      } catch (error) {
        console.error('Error retrieving vendors:', error);
      }
    },
  },
  async created() {
    this.$options.components.buttonCellRenderer = ButtonCellRenderer;
    this.$options.components.badgeCellRenderer = BadgeCellRenderer;
    // this.$options.components.iconCellRenderer = IconCellRenderer;
    await this.loadData();
  }
}
</script>

<style lang="scss" scoped></style>
